import {AXIOS} from '../constants/axios';

export default {
  signIn: signIn,
  signUp: signUp,
  update: update,
  search: search,
  create: create,
  get: get,
  updateCurrent: updateCurrent,
  synchronize: synchronize,
  updateSuperHeroes: updateSuperHeroes,
  createListingBusinessPartner: createListingBusinessPartner,
  updateUserParams: updateUserParams,
}

function signIn(body){
  return AXIOS.post('/users/sign_in', body);
}

function signUp(body){
  return AXIOS.post('/users', body);
}

function update(body){
  return AXIOS.put('/users', body);
}

function updateUserParams(user_id, body){
  return AXIOS.put(`/api/internal/users/${user_id}/update_user_params_by_admin`, body)
}

function search(params){
  return AXIOS.get('/users', {params: params});
}

function synchronize(userId){
  return AXIOS.put(`/users/${userId}/closeio/synchronization`);
}

function updateSuperHeroes(userId, body){
  return AXIOS.patch(`/users/${userId}/super-heroes`, body);
}

function create(body){
  return AXIOS.post('/users', body);
}

function createListingBusinessPartner(body){
  return AXIOS.post('/api/internal/listing_business_partners', body)
}

function updateCurrent(body){
  return AXIOS.put('/api/internal/users/update_using_current.json', body);
}

function get(userId){
  return AXIOS.get(`/users/${userId}`);
}